var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667C8.654 2.667 2.667 8.653 2.667 16S8.654 29.333 16 29.333c7.347 0 13.334-5.986 13.334-13.333S23.347 2.667 16 2.667zm-1 8c0-.547.454-1 1-1 .547 0 1 .453 1 1v6.666c0 .547-.453 1-1 1-.546 0-1-.453-1-1v-6.666zm2.227 11.173c-.067.173-.16.307-.28.44-.133.12-.28.213-.44.28-.16.067-.333.107-.507.107-.173 0-.346-.04-.506-.107a1.538 1.538 0 0 1-.44-.28 1.374 1.374 0 0 1-.28-.44 1.326 1.326 0 0 1-.107-.507c0-.173.04-.346.107-.506.066-.16.16-.307.28-.44.133-.12.28-.214.44-.28.32-.134.693-.134 1.013 0 .16.066.307.16.44.28.12.133.213.28.28.44.067.16.107.333.107.506 0 .174-.04.347-.107.507z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info_error.0a6a090e9e2a22b59822636e12c442fc.svg";
export { ForwardRef as ReactComponent };